export interface CxpPermissions {
  canViewTasks: boolean;
  /**
   * Whether the caller may change who has access (invite, remove). False for a
   * guest: they act on the items their link grants, never on the access list.
   */
  canManageAccess: boolean;
  /**
   * Whether the caller gets the comments surface at all — the overlay's Comments
   * tab and the row's comment add-on. False for a guest: a secure-link session's
   * contact id is the INVITER's, so anything it read or marked as viewed would be
   * attributed to somebody else.
   */
  canViewComments: boolean;
  /**
   * Whether the caller may drop files on the REQUEST-level bulk dropzone. False
   * for a guest: a secure link grants specific items, while a bulk drop is aimed
   * at the request as a whole and the backend decides which item each file lands
   * on — possibly one the guest was never given.
   *
   * Independent of {@link canViewUncategorizedFiles} in both directions.
   */
  canBulkUpload: boolean;
  /**
   * Whether the caller may see the request's uncategorized files — everything
   * dropped on the bulk dropzone that the backend has not yet assigned to an
   * item. False for a guest: those files belong to the request rather than to
   * the items their link named, however they got there.
   *
   * Independent of {@link canBulkUpload} in both directions.
   */
  canViewUncategorizedFiles: boolean;
}

export const DEFAULT_CXP_PERMISSIONS: CxpPermissions = {
  canViewTasks: false,
  canManageAccess: false,
  canViewComments: false,
  canBulkUpload: false,
  canViewUncategorizedFiles: false,
};
